import { useContext, useState, useEffect } from "react";
import { purchaseOrdersContext } from "../../contexts/PurchaseOrdersContext";
import { AuthContext } from "../../contexts/AuthContext";

function PurchaseOrderFilters() {
    const { filters, setFilters, billingEntities } = useContext(purchaseOrdersContext);
    const { token } = useContext(AuthContext);

    const currencies = [
        { id: 1, name: "EUR" },
        { id: 2, name: "USD" },
        { id: 3, name: "PLN" },
    ]

    const [customersFromDb, setCustomersFromDb] = useState([]);

    useEffect(() => {
        const abortController = new AbortController();
        
        const fetchCustomers = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_endPoint + '/v1/customers', {
					credentials: "include",
					signal: abortController.signal
                });
                const data = await response.json();
                setCustomersFromDb(data.customers);
            } catch (error) {
                if (error.name !== 'AbortError') {
                    console.error('Error fetching customers:', error);
                }
            }
        };
        
        fetchCustomers();
        
        return () => {
            abortController.abort();
        };
    }, [token]);

	return (
		<div className={"m-2 border p-4 bg-white shadow-sm"}>
            <h3>Filters</h3>
			<form>
                <div className="row mb-3">
                    <div className="col">
                        <label htmlFor="search" className={"form-label"}>Search:</label><br/>
                        <input type="text" placeholder="Search by customer name, PO number" id="search" className={"form-control"} value={filters.search} onChange={(evt) => {
                            setFilters(prev => { return {...prev, search: evt.target.value} })
                        }} />
                    </div>
                    <div className="col">
                        <label htmlFor="archived" className={"form-label"}>Archived:</label>
                        <select id="archived" className={"form-select"} value={filters.archived} onChange={(evt) => {
                            setFilters(prev => { return {...prev, archived: evt.target.value} })
                        }}>
                            <option value="">Select an option</option>
                            <option value="0">Not archived</option>
                            <option value="1">Archived</option>
                        </select>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col">
                        <label htmlFor="customerId" className={"form-label"}>Customer:</label>
                        <select id="customerId" className={"form-select"} value={filters.customerId} multiple={true} onChange={(evt) => {
                            setFilters(prev => { return {...prev, customerId: Array.from(evt.target.selectedOptions, option => option.value)} })
                        }}>
                            <option value="">Select an option</option>
                            {customersFromDb.map(value => {
                                return <option key={value.id} value={value.id}>{value.firstName} {value.lastName}</option>
                            })}
                        </select>
                    </div>
                    <div className="col">
                        <label htmlFor="currencyId" className={"form-label"}>Currency:</label>
                        <select id="currencyId" className={"form-select"} value={filters.currencyId} multiple={true} onChange={(evt) => {
                            setFilters(prev => { return {...prev, currencyId: Array.from(evt.target.selectedOptions, option => option.value)} })
                        }}>
                            <option value="">All</option>
                            {currencies.map(value => {
                                return <option key={value.id} value={value.id}>{value.name}</option>
                            })}
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label htmlFor="billingEntityId" className={"form-label"}>Billing entity:</label><br/>
                        <select id="billingEntityId" className={"form-select"} value={filters.billingEntityId} onChange={(evt) => {
                            setFilters(prev => { return {...prev, billingEntityId: evt.target.value} })
                        }}>
                            <option value="">Select an option</option>
                            {billingEntities.map(value => {
                                return <option key={value.id} value={value.id}>{value.name}</option>
                            })}
                        </select>
                    </div>
                    <div className="col">
                        <label htmlFor="consumed" className={"form-label"}>State:</label><br/>
                        <select id="consumed" className={"form-select"} value={filters.consumed} onChange={(evt) => {
                            setFilters(prev => { return {...prev, consumed: evt.target.value} })
                        }}>
                            <option value="0">All</option>
                            <option value="1">Available</option>
                            <option value="2">Consumed</option>
                        </select>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col">
                        <label htmlFor="startIssueDate">Start Issue Date</label>
                        <input type="date" className="form-control" id="startIssueDate" name="startIssueDate" onChange={(evt) => {
                            setFilters(prev => { return {...prev, startIssueDate: evt.target.value }});
                        }} />
                    </div>
                    <div className="col">
                        <label htmlFor="endIssueDate">End Issue Date</label>
                        <input type="date" className="form-control" id="endIssueDate" name="endIssueDate" onChange={(evt) => {
                            setFilters(prev => { return {...prev, endIssueDate: evt.target.value }});
                        }} />
                    </div>
                </div>
			</form>
		</div>
	);
}

export default PurchaseOrderFilters;
